import React from 'react'
import useParticipations from './use-discussion-participations'
import Participation from './participation'
import { first, get, last } from 'lodash'
import { Spinner } from 'react-bootstrap'

const Participations = ({
    discussionId
}) => {
    const [scrollPos, setScrollPos] = React.useState(-100)
    const {
        participations,
        isLoading,
        canFetchMore,
        fetchMore,
        pages,
    } = useParticipations({ discussionId })
    const messagesEndRef = React.useRef(null)
    const lastPageRef = React.useRef(null)
    const lastMessageDate = get(first(participations), 'createdDate')
    const pagesCount = pages.length

    const scrollToBottom = () => {
        if(messagesEndRef.current){
            messagesEndRef.current.scrollIntoView({ behavior: 'auto' })
        }
    }

    const scrollToLastPage = () => {
        if(lastPageRef.current){
            lastPageRef.current.scrollIntoView({ behavior: 'auto' })
        }
    }

    React.useEffect(() => {
        if (lastMessageDate) {
            scrollToBottom()
        }
    }, [lastMessageDate, discussionId])

    React.useEffect(() => {
        if (pagesCount) {
            scrollToLastPage()
        }
    }, [pagesCount])

    React.useEffect(() => {
        if (!scrollPos) {
            fetchMore()
        }
        
    }, [scrollPos, canFetchMore])

    const handleScroll = (e) => {
        setScrollPos(e.target.scrollTop)
    }

    const renderParticipation = (participation, index, items) => {
        const isLastPageStart = first(last(pages)).id === participation.id
        return (
            <React.Fragment key={participation.id} >
                <Participation participation={participation} />
                <div ref={isLastPageStart ? lastPageRef : undefined} />
            </React.Fragment>
        )
    }

    return (
        <div
            style={{
                height: 'calc(100%)',
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'column'
            }}
            onScroll={handleScroll}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-around'
                }}
            >
                {isLoading && <Spinner animation="border" size="sm" />}
            </div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column-reverse'
                }}
            >
                {participations.map(renderParticipation)}
            </div>
            <div ref={messagesEndRef} />
        </div>
    )
}

export default Participations
